<template>
  <div class="Sale">
    <div class="page-title">{{ title }}</div>

    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          :placeholder="searchPlaceholder"
          v-model="searchWord"
          clearable
          style="width: 300px;"
          @keydown.enter.native="handleClickFilter"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleClickFilter"
          />
        </el-input>

        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector
              ref="period"
              :value="search_period"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div>
      <ATable
        ref="table_contract"
        class="no-pointer"
        v-loading="loading_contract"
        max-height="359px"
        :data="filterDataContract"
        :row-class-name="soldTableRowClassName"
        border
        hide-button-insert
        hide-pagination
        @selection-change="contractSelectionChange"
      >
        <div slot="search" class="list-title">수주 리스트</div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexContract"
          :width="$width.index"
        />
        <el-table-column prop="code" label="수주번호" width="100" />
        <el-table-column
          prop="contract_date"
          label="수주일"
          :width="$width.date"
        />
        <el-table-column
          prop="delivery_date"
          label="납기일"
          :width="$width.date"
        />
        <el-table-column prop="customer_name" label="거래처" width="200" />
        <el-table-column prop="product_name" label="품목" />
        <el-table-column
          prop="price"
          class-name="cell-number"
          label="금액"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="contractSelection.length < 1 || !has_grant_write"
            @click="handleClickSaveSale"
            >매출 등록</el-button
          >
        </div>
      </ATable>
    </div>
    <div>
      <ATable
        ref="table_sale"
        class="no-pointer"
        v-loading="loading_sale"
        buttons-width="359px"
        max-height="359px"
        :page-size="10"
        :data="filterDataSale"
        border
        hide-button-insert
        hide-pagination
        @selection-change="saleSelectionChange"
      >
        <div slot="search" class="list-title">매출 리스트</div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :selectable="selectable"
        />
        <el-table-column
          prop="status_flag"
          label="상태"
          width="50"
          :formatter="saleStatusFormat"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexSale"
          :width="$width.index"
        />
        <el-table-column prop="contract_code" label="수주번호" width="100" />
        <el-table-column
          prop="seq"
          label="번호"
          width="50"
          :formatter="util.resolveSeq"
        />
        <el-table-column prop="sale_date" label="매출일" :width="$width.date" />
        <el-table-column
          prop="delivery_date"
          label="납기일"
          :width="$width.date"
        />
        <el-table-column prop="customer_name" label="거래처" width="200" />
        <el-table-column
          prop="product_name"
          label="품목"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          :width="$width.size"
        />
        <el-table-column
          prop="sale_amount"
          label="수량"
          class-name="cell-number"
          :width="$width.amount"
        />
        <el-table-column prop="unit_name" label="단위" width="50" />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          v-if="showPyungProcessingCost"
          prop="pyung_cost"
          label="평단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          v-if="showPyungProcessingCost"
          prop="item_processing_cost"
          label="가공비"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            :disabled="saleSelection.length < 1 || !has_grant_write"
            @click="handleClickBulkChange"
            >{{ $t("button.bulk_change") }}</el-button
          >
          <el-button :disabled="!has_grant_write" @click="handleClickInsertSale"
            >수기 매출</el-button
          >
          <el-button
            type="danger"
            :disabled="saleSelection.length < 1 || !has_grant_write"
            @click="handleClickDeleteSale"
            >매출 취소</el-button
          >
        </div>
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      title="수기 매출"
      :visible.sync="dialogVisible"
      destroyOnClose
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <SaleForm ref="form" :data="form_data" @completed="handleCompleted" />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      :title="$t('button.bulk_change')"
      :visible.sync="dialog2Visible"
      :close-on-click-modal="false"
    >
      <SaleBulkChange
        v-if="dialog2Visible"
        :ids="selectionIds"
        @completed="handleCompletedBulkChange"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { company_info } from "@/common/mixins/company_info";
import SaleForm from "./SaleForm";
import SaleBulkChange from "./SaleBulkChange";

export default {
  name: "Sale",
  mixins: [form_container, authority_level, company_info],
  components: { SaleForm, SaleBulkChange },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      title: this.$t("title.sale_reg"),
      search_period: { value: "0d" },
      period: {},
      searchPlaceholder: "수주번호, 거래처, 납기일, 품목",
      search_field: [
        "code",
        "contract_code",
        "customer_name",
        "delivery_date",
        "product_name",
      ],
      searchWord: null,
      fixedSearchWord: "",
      dialogVisible: false,
      dialog2Visible: false,
      loading_contract: false,
      items_contract: [],
      contractSelection: [],
      loading_sale: false,
      items_sale: [],
      saleSelection: [],
      form_data: undefined,
    };
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    /* 수주 */
    filterDataContract: function() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord
      );
    },
    /* 매출 */
    filterDataSale: function() {
      return this.util.filterMultiFields(
        this.items_sale,
        this.search_field,
        this.fixedSearchWord
      );
    },
    selectionIds() {
      if (this.saleSelection.length < 1) {
        return [];
      }
      return this.saleSelection.map((s) => s.id);
    },
    has_grant_write() {
      return this.isWriteLevel("sale_reg");
    },
  },
  mounted() {
    this.loadConfig()
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    selectable(row /*, index*/) {
      return row.status_flag !== "1";
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
    },
    loadSaleContract() {
      this.loading_contract = true;
      this.api.listContractNonSale(this.period).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data;
        this.items_contract.forEach((item) => {
          item.product_name = this.productNaming(item);
        });
      });
    },
    loadSale() {
      this.loading_sale = true;
      this.api.listSale(this.period).then((res) => {
        this.loading_sale = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_sale = res.data;
      });
    },
    loadData() {
      this.loadSaleContract();
      this.loadSale();
    },
    compareContract() {
      return function(a, b) {
        if (a.code < b.code) {
          return -1;
        } else if (a.code === b.code) {
          return a.seq - b.seq;
        } else {
          return 1;
        }
      };
    },
    soldTableRowClassName({ row /*, rowIndex*/ }) {
      if (row.production_amount > 0) return "sold-row";
      return "";
    },
    contractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    saleSelectionChange(selection) {
      this.saleSelection = selection;
    },
    handleCurrentChangeContract(value) {
      this.currentPageContract = value;
    },
    handleCurrentChangeSale(value) {
      this.currentPageSale = value;
    },
    handleIndexContract(index) {
      return this.$refs.table_contract.indexResolver(index);
    },
    handleIndexSale(index) {
      return this.$refs.table_sale.indexResolver(index);
    },
    async handleClickSaveSale() {
      const hasReturn = this.contractSelection.some((item) =>
        item.details.some((d) => d.amount < 0)
      );
      if (hasReturn) {
        let confirm = await new Promise((resolve) => {
          this.util.confirm(
            this,
            this.title,
            "반품 건이 포함되어있을 경우 처리 시간이 더 소요될 수 있습니다. 등록하시겠습니까?",
            () => {
              resolve(true);
            },
            () => {
              resolve(false);
            }
          );
        });
        if (!confirm) return;
      }
      if (this.contractSelection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      this.loading_contract = true;
      let params = this.contractSelection.map((item) => item.id);
      this.api.registerSale(params).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
      });
    },
    productNaming(item) {
      if (item.details.length < 1) {
        return "";
      } else if (item.details.length > 1) {
        return (
          item.details[0].product_name +
          " 외 " +
          (item.details.length - 1) +
          "건"
        );
      } else {
        return item.details[0].product_name;
      }
    },
    handleClickDeleteSale() {
      if (this.saleSelection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      let messsage =
        "취소시 해당 수주의 모든 매출이 취소됩니다. 취소하시겠습니까?";

      /** 삭제 */
      this.util.confirm_delete(this, this.title, this.doDelete, messsage);
    },
    doDelete() {
      this.loading_sale = true;
      let params = this.selectionIds;
      this.api.deleteSale(params).then((res) => {
        this.loading_sale = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.$t("title.sale"), res);
          return;
        }
        this.handleClickSearch();
      });
    },
    saleStatusFormat(row, cell, cellValue) {
      return cellValue === "1" ? "완료" : "진행";
    },
    handleClickInsertSale() {
      this.dialogVisible = true;
    },
    handleCompleted(result) {
      this.dialogVisible = false;
      this.form_data = undefined;
      if (!result) {
        return;
      }
      this.loadSale();
    },
    handleClickBulkChange() {
      this.dialog2Visible = true;
    },
    handleCompletedBulkChange(result) {
      this.dialog2Visible = false;
      if (!result) {
        return;
      }
      this.loadSale();
    },
  },
};
</script>
